
import img1 from '@/assets/img/business/1.png'
import img2 from '@/assets/img/business/2.png'
import img3 from '@/assets/img/business/3.png'
import img4 from '@/assets/img/business/4.png'
import img5 from '@/assets/img/business/5.png'
import img6 from '@/assets/img/business/6.png'
import img7 from '@/assets/img/business/7.png'
import img8 from '@/assets/img/business/8.png'
import img9 from '@/assets/img/business/9.png'
import img10 from '@/assets/img/business/10.png'
import img11 from '@/assets/img/business/11.png'

import Api from '@/api/api.js'
import { unique } from '@/utils/global'
import Vue from 'vue'

export default {
  state: {
    openid: null,
    subscribeInfo: {
      businessType: [],
      industryData: [],
      acquisMethodData: [],
      areaData: []
    },
    businessTypeList: [{
      value: '01',
      sourceUrl: img1,
      name: '工程建设'
    }, {
      value: '02',
      sourceUrl: img2,
      name: '政府采购'
    }, {
      value: '03',
      sourceUrl: img3,
      name: '土地使用权'
    }, {
      value: '04',
      sourceUrl: img4,
      name: '矿业权'
    }, {
      value: '05',
      sourceUrl: img5,
      name: '国有产权'
    }
      // {
      //     value: '21',
      //     sourceUrl: img6,
      //     name: '碳排放权'
      // }, {
      //     value: '22',
      //     sourceUrl: img7,
      //     name: '排污权'
      // }, {
      //     value: '23',
      //     sourceUrl: img8,
      //     name: '药品采购'
      // }, {
      //     value: '24',
      //     sourceUrl: img9,
      //     name: '二类疫苗'
      // }, {
      //     value: '25',
      //     sourceUrl: img10,
      //     name: '林权'
      // },
      // {
      //     value: '90',
      //     sourceUrl: img11,
      //     name: '其他'
      // }
    ],
    serviceTypeList: [],
    timeRange: [],
    industryTypeList: [], //  行业类型
    areaData: [], //  区域数据
    historyList: [],
    busInfoList: [],
    busInfoAndIndustryTypeList: [], //  业务信息和对应的行业数据
    cachedComponents: [], // 存储需要缓存的组件名称
    searchKeyList: [{
      title: '搜项目(标题)',
      value: 1,
      select: false
    }, {
      title: '搜项目(全文)',
      value: 2,
      select: false
    }]
  },
  mutations: {
    changeRecruitScrollY(state, param) {
      if (param.name) {
        state[param.name] = param.position
      } else {
        state.recruitScrollY = param.position
      }
    },
    changeOpenid(state, param) {
      state.openid = param
    },
    setDictCodeForServiceType(state, param) {
      state.serviceTypeList = param
    },
    setTimeRange(state, param) {
      state.timeRange = param
    },
    setIndustryTypeList(state, param) {
      state.industryTypeList = param
    },
    setAreaData(state, param) {
      state.areaData = param
    },
    setHistoryList(state, param) {
      state.historyList = param
    },
    setBusInfoList(state, param) {
      state.busInfoList = param
    },
    setSingleHistory(state, param) {
      state.historyList.unshift(param)
      localStorage.setItem('HistoryRecordOfProject', JSON.stringify(state.historyList))
    },
    setBusInfoAndIndustryTypeList(state, param) {
      state.busInfoAndIndustryTypeList = param
    },
    ADD_CACHED_COMPONENT(state, componentName) {
      if (!state.cachedComponents.includes(componentName)) {
        state.cachedComponents.push(componentName)
      }
    },
    REMOVE_CACHED_COMPONENT(state, componentName) {
      const index = state.cachedComponents.indexOf(componentName)
      if (index > -1) {
        state.cachedComponents.splice(index, 1)
      }
    },
    CLEAR_CACHED_COMPONENTS(state) {
      state.cachedComponents = []
    }
  },
  actions: {
    getHistoryList({ dispatch, state, commit, getters }) {
      // 获取搜索历史记录
      var historyList = localStorage.getItem('HistoryRecordOfProject')

      // 获取本地的历史记录数据，默认值为空数据
      var list = historyList ? JSON.parse(historyList) : []

      // 去除为空字符串的数据
      for (var i = 0; i < list.length; i++) {
        if (list[i] == '') {
          list.splice(i, 1)
          i--
        }
      }

      commit('setHistoryList', unique(list))
      localStorage.setItem('HistoryRecordOfProject', JSON.stringify(list))
    },
    setSingHistory({ dispatch, state, commit, getters }, value) {
      // 如果搜索内容为空，则不保存搜索内容
      if (value == '') {
        return
      }
      for (var i = 0; i < state.historyList.length; i++) {
        if (value == state.historyList[i]) {
          state.historyList.splice(i, 1)
        }
      }
      commit('setSingleHistory', value)
    },
    addCacheComponent({ commit }, componentName) {
      commit('ADD_CACHED_COMPONENT', componentName)
    },
    removeCacheComponent({ commit }, componentName) {
      commit('REMOVE_CACHED_COMPONENT', componentName)
    },
    clearCacheComponents({ commit }) {
      commit('CLEAR_CACHED_COMPONENTS')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js